import { render, staticRenderFns } from "./pagination-with-keyword.vue?vue&type=template&id=0a28cd9e"
import script from "./pagination-with-keyword.vue?vue&type=script&lang=js"
export * from "./pagination-with-keyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports